import { NSBaseMetaDatabase, NSBaseMetaTable, NSBaseServer } from "namirasoft-site";
import { NamirasoftAPILinkMetaDatabase } from "namirasoft-api-link";
import { NamirasoftAPINewsMetaDatabase } from "namirasoft-api-news";
import { NamirasoftAPIProductMetaDatabase } from "namirasoft-api-product";
import { NamirasoftAPIServiceMetaDatabase } from "namirasoft-api-service";
import { NamirasoftAPIWorkMetaDatabase } from "namirasoft-api-work";
import { NamirasoftAccessMetaDatabase } from "namirasoft-access";
import { NamirasoftAccountMetaDatabase, TokenManager } from "namirasoft-account";
import { NamirasoftAlarmMetaDatabase } from "namirasoft-alarm";
import { NamirasoftBalanceMetaDatabase } from "namirasoft-balance";
import { NamirasoftContentTemplateMetaDatabase } from "namirasoft-content-template";
import { NamirasoftDataMetaDatabase } from "namirasoft-data";
import { NamirasoftEmailSenderMetaDatabase } from "namirasoft-email-sender";
import { NamirasoftFieldMetaDatabase } from "namirasoft-field";
import { NamirasoftHistoryMetaDatabase } from "namirasoft-history";
import { NamirasoftJobArrangerMetaDatabase } from "namirasoft-job-arranger";
import { NamirasoftLogMetaDatabase } from "namirasoft-log";
import { NamirasoftMessageMetaDatabase } from "namirasoft-message";
import { NamirasoftNWSMaxMindMetaDatabase } from "namirasoft-nws-max-mind";
import { NamirasoftNWSRegionMetaDatabase } from "namirasoft-nws-region";
import { NamirasoftNotificationSenderMetaDatabase } from "namirasoft-notification-sender";
import { NamirasoftPaymentMetaDatabase } from "namirasoft-payment";
import { NamirasoftSMSSenderMetaDatabase } from "namirasoft-sms-sender";
import { NamirasoftSecretMetaDatabase } from "namirasoft-secret";
import { NamirasoftWorkspaceMetaDatabase } from "namirasoft-workspace";
import { NamirasoftTelegramSenderMetaDatabase } from "namirasoft-telegram-sender";
import { NamirasoftCredentialMetaDatabase } from "namirasoft-credential";
import { NamirasoftBillWatchMetaDatabase } from "namirasoft-bill-watch";

export class NamirasoftMap
{
    // tables define start
    public api_link: NamirasoftAPILinkMetaDatabase;
    public api_news: NamirasoftAPINewsMetaDatabase;
    public api_product: NamirasoftAPIProductMetaDatabase;
    public api_service: NamirasoftAPIServiceMetaDatabase;
    public api_work: NamirasoftAPIWorkMetaDatabase;
    public access: NamirasoftAccessMetaDatabase;
    public account: NamirasoftAccountMetaDatabase;
    public alarm: NamirasoftAlarmMetaDatabase;
    public balance: NamirasoftBalanceMetaDatabase;
    public bill_watch: NamirasoftBillWatchMetaDatabase;
    public content_template: NamirasoftContentTemplateMetaDatabase;
    public credential: NamirasoftCredentialMetaDatabase;
    public data: NamirasoftDataMetaDatabase;
    public email_sender: NamirasoftEmailSenderMetaDatabase;
    public field: NamirasoftFieldMetaDatabase;
    public history: NamirasoftHistoryMetaDatabase;
    public job_arranger: NamirasoftJobArrangerMetaDatabase;
    public log: NamirasoftLogMetaDatabase;
    public message: NamirasoftMessageMetaDatabase;
    public nws_max_mind: NamirasoftNWSMaxMindMetaDatabase;
    public nws_region: NamirasoftNWSRegionMetaDatabase;
    public notification_sender: NamirasoftNotificationSenderMetaDatabase;
    public payment: NamirasoftPaymentMetaDatabase;
    public sms_sender: NamirasoftSMSSenderMetaDatabase;
    public secret: NamirasoftSecretMetaDatabase;
    public telegram_sender: NamirasoftTelegramSenderMetaDatabase;
    public workspace: NamirasoftWorkspaceMetaDatabase;
    // tables define end
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        // tables init start
        this.api_link = new NamirasoftAPILinkMetaDatabase(onError);
        this.api_news = new NamirasoftAPINewsMetaDatabase(onError);
        this.api_product = new NamirasoftAPIProductMetaDatabase(onError);
        this.api_service = new NamirasoftAPIServiceMetaDatabase(onError);
        this.api_work = new NamirasoftAPIWorkMetaDatabase(onError);
        this.access = new NamirasoftAccessMetaDatabase(manager, onError);
        this.account = new NamirasoftAccountMetaDatabase(manager, onError);
        this.alarm = new NamirasoftAlarmMetaDatabase(manager, onError);
        this.balance = new NamirasoftBalanceMetaDatabase(manager, onError);
        this.bill_watch = new NamirasoftBillWatchMetaDatabase(manager, onError);
        this.content_template = new NamirasoftContentTemplateMetaDatabase(manager, onError);
        this.credential = new NamirasoftCredentialMetaDatabase(manager, onError);
        this.data = new NamirasoftDataMetaDatabase(manager, onError);
        this.email_sender = new NamirasoftEmailSenderMetaDatabase(manager, onError);
        this.field = new NamirasoftFieldMetaDatabase(manager, onError);
        this.history = new NamirasoftHistoryMetaDatabase(manager, onError);
        this.job_arranger = new NamirasoftJobArrangerMetaDatabase(manager, onError);
        this.log = new NamirasoftLogMetaDatabase(manager, onError);
        this.message = new NamirasoftMessageMetaDatabase(manager, onError);
        this.nws_max_mind = new NamirasoftNWSMaxMindMetaDatabase(manager, onError);
        this.nws_region = new NamirasoftNWSRegionMetaDatabase(manager, onError);
        this.notification_sender = new NamirasoftNotificationSenderMetaDatabase(manager, onError);
        this.payment = new NamirasoftPaymentMetaDatabase(manager, onError);
        this.sms_sender = new NamirasoftSMSSenderMetaDatabase(manager, onError);
        this.secret = new NamirasoftSecretMetaDatabase(manager, onError);
        this.telegram_sender = new NamirasoftTelegramSenderMetaDatabase(manager, onError);
        this.workspace = new NamirasoftWorkspaceMetaDatabase(manager, onError);

        // tables init end

        this.api_product.tables.product.front_end.getViewLink = (id: string) =>
        {
            return this.getByProductID(id).product.link;
        };
        this.account.tables.user.front_end.getViewLink = (id: string) =>
        {
            return this.account.tables.user.front_end.getBaseLink() + "/" + id + "/view/decide";
        };
        this.account.tables.session.front_end.getViewLink = (id: string) =>
        {
            return this.account.tables.session.front_end.getBaseLink() + "/" + id + "/view/decide";
        };
    }
    forEachProduct<T>(handler: (meta: NSBaseMetaDatabase<NSBaseServer>) => T | null): T | null
    {
        for (let key of Object.keys(this))
        {
            let obj = (this as any)[key];
            if (obj?.tables)
            {
                let ans = handler(obj);
                if (ans)
                    return ans;
            }
        }
        return null;
    }
    getByProductID(product_id: string): NSBaseMetaDatabase<NSBaseServer>
    {
        let ans = this.forEachProduct(m =>
        {
            if (m.product.id === product_id)
                return m;
            return null;
        });
        if (ans)
            return ans;
        throw new Error(`Map could not be found for product id: ${product_id}`);
    }
    getByShortName(short_name: string):
        {
            product: {
                id: string;
                name: string;
                headline: string;
                description: string;
                logo: string;
                link: string;
            };
            table: NSBaseMetaTable<NSBaseServer, any>;
        }
    {
        let ans = this.forEachProduct(product =>
        {
            return product.getByShortNameOrNull(short_name);
        });
        if (ans)
            return ans;
        throw new Error(`Result could not be found for short name: ${short_name}`);
    }
};